"use client";

import { c as _c } from "react/compiler-runtime";
import RememeImage from "@/components/nft-image/RememeImage";
import Pagination from "@/components/pagination/Pagination";
import { printMemeReferences } from "@/components/rememes/RememePage";
import { RememeSort } from "@/components/rememes/Rememes";
import { publicEnv } from "@/config/env";
import { OPENSEA_STORE_FRONT_CONTRACT } from "@/constants/constants";
import type { DBResponse } from "@/entities/IDBResponse";
import type { NFT, Rememe } from "@/entities/INFT";
import { areEqualAddresses, formatAddress, numberWithCommas } from "@/helpers/Helpers";
import { fetchUrl } from "@/services/6529api";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import styles from "./TheMemes.module.scss";
const REMEMES_PAGE_SIZE = 20;
function buildRememesUrl(memeId: number, page: number, sorting: RememeSort) {
  const sort = sorting === RememeSort.CREATED_ASC ? "&sort=created_at&sort_direction=desc" : "";
  return `${publicEnv.API_ENDPOINT}/api/rememes?meme_id=${memeId}&page_size=${REMEMES_PAGE_SIZE}&page=${page}${sort}`;
}
function getRememeName(rememe: Rememe) {
  const metadata = rememe.metadata as unknown;
  if (metadata !== null && typeof metadata === "object" && "name" in metadata && typeof metadata.name === "string" && metadata.name.trim()) {
    return metadata.name;
  }
  return `${formatAddress(rememe.contract)} #${rememe.id}`;
}
export function MemePageReferencesSubMenu(props) {
  const $ = _c(43);
  const [memeLabNftsLoaded, setMemeLabNftsLoaded] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [memeLabNfts, setMemeLabNfts] = useState(t0);
  const [rememesTotalResults, setRememesTotalResults] = useState(0);
  const [rememesPage, setRememesPage] = useState(1);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [rememes, setRememes] = useState(t1);
  const [showRememesSort, setShowRememesSort] = useState(false);
  const [rememesLoaded, setRememesLoaded] = useState(false);
  const rememesTarget = useRef(null);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [RememeSort.RANDOM, RememeSort.CREATED_ASC];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const rememeSorting = t2;
  const [selectedRememeSorting, setSelectedRememeSorting] = useState(RememeSort.RANDOM);
  let t3;
  if ($[3] !== rememesPage || $[4] !== selectedRememeSorting) {
    t3 = function refreshRememes(memeId) {
      fetchUrl(buildRememesUrl(memeId, rememesPage, selectedRememeSorting)).then(response => {
        setRememesTotalResults(response.count);
        setRememes(response.data);
        setShowRememesSort(response.count > REMEMES_PAGE_SIZE);
        setRememesLoaded(true);
      }).catch(() => {
        setRememesTotalResults(0);
        setRememes([]);
        setShowRememesSort(false);
        setRememesLoaded(true);
      });
    };
    $[3] = rememesPage;
    $[4] = selectedRememeSorting;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const refreshRememes = t3;
  let t4;
  let t5;
  if ($[6] !== props.nft || $[7] !== props.show) {
    t4 = () => {
      if (props.show && props.nft) {
        fetchUrl(`${publicEnv.API_ENDPOINT}/api/nfts_memelab?sort_direction=asc&meme_id=${props.nft.id}`).then(response_0 => {
          setMemeLabNfts(response_0.data);
          setMemeLabNftsLoaded(true);
        }).catch(() => {
          setMemeLabNfts([]);
          setMemeLabNftsLoaded(true);
        });
      }
    };
    t5 = [props.show, props.nft];
    $[6] = props.nft;
    $[7] = props.show;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[10] !== props.nft || $[11] !== props.show || $[12] !== rememesPage || $[13] !== selectedRememeSorting) {
    t6 = () => {
      if (props.show && props.nft) {
        fetchUrl(buildRememesUrl(props.nft.id, rememesPage, selectedRememeSorting)).then(response_1 => {
          setRememesTotalResults(response_1.count);
          setRememes(response_1.data);
          setShowRememesSort(response_1.count > REMEMES_PAGE_SIZE);
          setRememesLoaded(true);
        }).catch(() => {
          setRememesTotalResults(0);
          setRememes([]);
          setShowRememesSort(false);
          setRememesLoaded(true);
        });
      }
    };
    t7 = [props.show, props.nft, rememesPage, selectedRememeSorting];
    $[10] = props.nft;
    $[11] = props.show;
    $[12] = rememesPage;
    $[13] = selectedRememeSorting;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  if (!props.show) {
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <></>;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    return t8;
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Row className="pt-3"><Col><Image unoptimized={true} width="0" height="0" style={{
          width: "250px",
          height: "auto"
        }} src="/memelab.png" alt="memelab" /></Col></Row>;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Row className="pt-4 pb-2"><Col>The Meme Lab is the lab for Meme Artists to release work that is related to The Meme Cards.</Col></Row>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== memeLabNfts || $[20] !== memeLabNftsLoaded) {
    t10 = printMemeReferences(memeLabNfts, "meme-lab", memeLabNftsLoaded, true);
    $[19] = memeLabNfts;
    $[20] = memeLabNftsLoaded;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <h1 className="mb-0 pt-2"><Image unoptimized={true} width="0" height="0" style={{
        width: "250px",
        height: "auto",
        float: "left"
      }} src="/re-memes.png" alt="re-memes" /></h1>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== props.nft || $[24] !== refreshRememes || $[25] !== selectedRememeSorting || $[26] !== showRememesSort) {
    t12 = showRememesSort && <span className="d-flex align-items-center gap-2 pt-2"><Dropdown className={styles.rememesSortDropdown} drop="down-centered"><Dropdown.Toggle>Sort: {selectedRememeSorting}</Dropdown.Toggle><Dropdown.Menu>{rememeSorting.map(s => <Dropdown.Item key={`sorting-${s}`} onClick={() => {
            setRememesPage(1);
            setRememesTotalResults(0);
            setSelectedRememeSorting(s);
          }}>{s}</Dropdown.Item>)}</Dropdown.Menu></Dropdown>{selectedRememeSorting === RememeSort.RANDOM && <><FontAwesomeIcon icon={faRefresh} className={styles.buttonIcon} onClick={() => {
          if (props.nft) {
            refreshRememes(props.nft.id);
          }
        }} data-tooltip-id="refresh-rememes" /><Tooltip id="refresh-rememes" place="top" delayShow={250} style={{
          backgroundColor: "#f8f9fa",
          color: "#212529",
          padding: "4px 8px"
        }}>Refresh results</Tooltip></>}</span>;
    $[23] = props.nft;
    $[24] = refreshRememes;
    $[25] = selectedRememeSorting;
    $[26] = showRememesSort;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12) {
    t13 = <Row className="pt-3" ref={rememesTarget}><Col className="d-flex flex-wrap align-items-center justify-content-between">{t11}{t12}</Col></Row>;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Row className="pt-4 pb-2"><Col>ReMemes are community-created and community-submitted NFTs inspired by the Meme Cards. They are not created or "authorized" by 6529 Collections.</Col></Row>;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== rememes.length || $[32] !== rememesLoaded) {
    t15 = rememesLoaded && rememes.length === 0 && <Row className="pt-2 pb-4"><Col>ReMemes that reference this NFT will appear here.</Col></Row>;
    $[31] = rememes.length;
    $[32] = rememesLoaded;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== rememes || $[35] !== rememesPage || $[36] !== rememesTotalResults) {
    t16 = rememes.length > 0 && <><Row className="py-2">{rememes.map(_temp)}</Row>{rememesTotalResults > REMEMES_PAGE_SIZE && <Row className="text-center pt-2 pb-3"><Pagination page={rememesPage} pageSize={REMEMES_PAGE_SIZE} totalResults={rememesTotalResults} setPage={function (newPage) {
          setRememesPage(newPage);
          if (rememesTarget.current) {
            rememesTarget.current.scrollIntoView({
              behavior: "smooth"
            });
          }
        }} /></Row>}</>;
    $[34] = rememes;
    $[35] = rememesPage;
    $[36] = rememesTotalResults;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t10 || $[39] !== t13 || $[40] !== t15 || $[41] !== t16) {
    t17 = <>{t8}{t9}{t10}{t13}{t14}{t15}{t16}</>;
    $[38] = t10;
    $[39] = t13;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  return t17;
}
function _temp(rememe) {
  return <Col key={`${rememe.contract}-${rememe.id}`} className="py-3" xs={{
    span: 6
  }} sm={{
    span: 4
  }} md={{
    span: 3
  }} lg={{
    span: 3
  }}><Link href={`/rememes/${rememe.contract}/${rememe.id}`} className="decoration-none scale-hover"><Container fluid={true} className="no-padding"><Row><Col><RememeImage nft={rememe} animation={false} height={300} /></Col></Row><Row><Col><Container><Row><Col className="font-smaller font-color-h d-flex justify-content-center align-items-center">{areEqualAddresses(rememe.contract, OPENSEA_STORE_FRONT_CONTRACT) ? <>{rememe.contract_opensea_data.collectionName}</> : <>{rememe.contract_opensea_data.collectionName ? rememe.contract_opensea_data.collectionName : formatAddress(rememe.contract)}{" "}#{rememe.id}</>}{rememe.replicas.length > 1 && <> (x{numberWithCommas(rememe.replicas.length)})</>}</Col></Row><Row><Col className="d-flex justify-content-center align-items-center"><span className="text-center">{getRememeName(rememe)}</span></Col></Row></Container></Col></Row></Container></Link></Col>;
}